module.exports = __webpack_public_path__ + "static/one-84ed5cfbb6957b5b8499eb327e298624.png";